<template>
  <NuxtLayout>
    <!-- Honor a page's definePageMeta({ key }) when set; otherwise remount on every fullPath change. -->
    <NuxtPage
      :keepalive="false"
      :pageKey="(r) => (typeof r.meta.key === 'function' ? r.meta.key(r) : r.meta.key) ?? r.fullPath"
    />
  </NuxtLayout>
  <GlobalLoadingOverlay />
</template>
<script lang="ts" setup>
const route = useRoute();
watch(route, () => {
  console.log('Navigating to a new page', route.fullPath);
});
useHead({
  bodyAttrs: {
    class: '!font-proxima',
  },
});

const router = useRouter();
const dashboardStore = useDashboardStore();

const userStore = useUserStore();

const getAndRedirect = async () => {
  await userStore.getCurrentUser();

  if (userStore.isSysAdmin) {
    await router.push('/dynamic-form/territory');
  } else if (userStore.hasOversight) {
    dashboardStore.clearData();
    await router.push('/oversight');
  } else {
    await router.push('/');
  }
};

if (sessionStorage.getItem('userUpdate') !== undefined && sessionStorage.getItem('userUpdate') === 'yes') {
  sessionStorage.removeItem('userUpdate');
  await getAndRedirect();
}

const channel = new BroadcastChannel('location_change');
channel.onmessage = async (event) => {
  if (event.data.type === 'location_update') {
    sessionStorage.setItem('userUpdate', 'yes');
    window.location.href = '/';
  }
};
</script>
